import React from 'react';

import Routes from './routes/Routes';

import { BrowserRouter } from 'react-router-dom';

// import { configureFakeBackend } from './helpers';

// Themes
// For Default import Theme.scss
import './assets/scss/Theme.scss';
import AnalyticsTracker from './AnalyticsTracker';

// For Dark import Theme-Dark.scss
// import './assets/scss/Theme-Dark.scss';

// configure fake backend
import { HelmetProvider } from 'react-helmet-async';

const App = () => {
    
    return (
        <HelmetProvider>
            <BrowserRouter>
                <AnalyticsTracker />
                <Routes></Routes>
            </BrowserRouter>
        </HelmetProvider>
    );
};

export default App;
